<!-- Header -->
@if(isNewPartner === true){
    <app-layout-row>
        <app-layout-column [width]="12">
            <div class="portalheader">Onboard Partner</div>
            <p class="portalheadertext">Here, you need to configure the options that will be presented to the partner on the onboarding page.   <br>After saving your changes, you will be able to preview the partner onboarding page and configure the email template that will be sent to the partner.</p>
        </app-layout-column>
    </app-layout-row>
}
@else {
    <app-layout-row>
        <app-layout-column [width]="12">
            <div class="portalheader">Onboarding Setup</div>
            <p class="">Here, you can edit the onboarding information for the selected partner.
        </app-layout-column>
    </app-layout-row>
}

<!-- Header buttons -->
@if (doneLoading()) {
    <app-layout-row margin="3rem">
        <app-layout-column [width]="12">
            <div class="menubuttons">
                @if (reactiveFormGroup.enabled) {
                    <app-button primary width="10rem" [disabled]="!reactiveFormGroup.valid" (buttonClick)="reactiveFormSubmit()">Save</app-button>
                    @if(isNewPartner === true){
                        <app-button primary width="20rem" [disabled]="!reactiveFormGroup.valid" (buttonClick)="saveAndSendToPartner()">Save and send to Partner</app-button>
                    }
                    <app-button secondary width="10rem" (buttonClick)="reactiveFormCancel()">Cancel</app-button>
                } @else {
                    <app-button *bizPermissionRequired="['Partner_Action_SendOnboarding']" primary width="10rem" (buttonClick)="reactiveFormEdit()">Edit</app-button>
                }
                @if(isNewPartner === false){
                    @if($safeNavigationMigration(partnerOnboarding()?.Id) !== null){
                        <app-button tertiery width="20rem" (buttonClick)="openPartnerPortal()">Open Partner Onboarding</app-button>
                        <app-button *bizPermissionRequired="['Partner_Action_SendOnboarding']" tertiery (buttonClick)="sendToPartner()" width="20rem" [disabled]="reactiveFormGroup.valid">Send invitation to partner</app-button>
                    }
                    <app-button *bizPermissionRequired="['Mail_View_Templates']" tertiery (buttonClick)="editMailTemplate()" width="15rem" [disabled]="reactiveFormGroup.valid">Preview Mail Template</app-button>
                }
            </div>
        </app-layout-column>
    </app-layout-row>
}

@if (doneLoading()) {
    <form [formGroup]="reactiveFormGroup">

        <!-- Presets -->
        <app-layout-row class="preset-row" margin="3rem">
            <app-layout-column [width]="6">
                <div class="preset-container">
                    <app-singleselectbox decorator
                        formControlName="onboardingPresetsControl"
                        caption="Choose a predefined preset"
                        [dataSource]="onboardingPresets()"
                        valueExpr="Id"
                        displayExpr="Name"
                        (valueChange)="onPresetChange($event)">
                    </app-singleselectbox>
                    <div class="preset-buttons-group">
                        <app-button tertiery (buttonClick)="saveOnboardingPreset()" [disabled]="formState() !== 'editing'"><i class="dx-icon-save"></i>Save</app-button>
                        <app-button tertiery (buttonClick)="saveAsOnboardingPreset()" [disabled]="formState() !== 'editing'"><i class="dx-icon-save"></i>Save New</app-button>
                        <app-button tertiery (buttonClick)="managePresets()" [disabled]="formState() === 'submitting'"><i class="dx-icon-preferences"></i>Manage Presets</app-button>
                    </div>
                </div>
            </app-layout-column>
        </app-layout-row>

        <!-- Onboarding configuration -->
        <app-layout-row margin="3rem">
            <app-layout-column [width]="12">
                <div class="sectionheader">Onboarding Configuration</div>
                @if(isNewPartner === true) {
                    <app-layout-row>
                        <app-layout-column [width]="6">
                            <app-textbox decorator formControlName="partnername" caption="Partner name"></app-textbox>
                        </app-layout-column>
                    </app-layout-row>
                }
                <app-layout-row>
                    <app-layout-column [width]="3">
                        <app-textbox decorator formControlName="email" caption="Partners contact email" infoText="We will send out an onboarding page link to the partner on this email. This will be the primary partner contact in the onboarding process."></app-textbox>
                    </app-layout-column>
                    <app-layout-column [width]="3">
                        <app-multiselectbox decorator
                            formControlName="contacttypes"
                            [dataSource]="contactTypes()"
                            valueExpr="Id"
                            displayExpr="Name"
                            caption="Partner contact type"
                            infoText="The types of contact this email address will be used for.">
                        </app-multiselectbox>
                    </app-layout-column>
                </app-layout-row>
                <app-layout-row>
                    <app-layout-column [width]="6">
                        <app-textbox decorator formControlName="notificationemail" caption="Your email" infoText="You will receive notifications about partner progress on this email. This will be your primary contact during the process."></app-textbox>
                    </app-layout-column>
                </app-layout-row>
            </app-layout-column>
        </app-layout-row>

        <!-- Identifications -->
        <app-layout-row margin="3rem">
            <app-layout-column [width]="12">
                <div class="sectionheader">Identification Types</div>
                @for (idtype of identificationTypesWrapper(); track idtype.IdentificationType.IdentificationTypeId)
                {
                    <app-layout-row>
                        <app-layout-column [width]="6">
                            <app-checkbox decorator="right-side" formControlName="idtypecheckbox_{{idtype.IdentificationType.IdentificationTypeId}}" caption="{{ idtype.IdentificationType.Name }}"></app-checkbox>
                        </app-layout-column>
                    </app-layout-row>
                }
            </app-layout-column>
        </app-layout-row>

        <!-- Ingoing Document Types -->
        <app-layout-row margin="3rem">
            <app-layout-column [width]="12">
                <div class="sectionheader">Ingoing Document Types</div>
                <p class="sectionheadertext">What kinds of documents does your <b>partner want to send to you</b>.<br>For each document type, choose one or more formats.<br>The partner will be able to suggest other document types and formats.</p>
                @for (docType of documentTypesInWrapper(); track docType.DocumentType.Id)
                {
                    <app-layout-row>
                        <app-layout-column [width]="6">
                            <app-checkbox decorator="right-side" formControlName="doctypeincheckbox_{{docType.DocumentType.Id}}" caption="{{ docType.DocumentType.Name }}"></app-checkbox>
                        </app-layout-column>
                    </app-layout-row>
                    @if(getFormControlValue("doctypeincheckbox_"+docType.DocumentType.Id) === true){
                        <app-layout-row>
                            <app-layout-column [width]="6">
                                    <div class="indent-properties">
                                        <app-multiselectbox decorator formControlName="doctypeinformat_{{docType.DocumentType.Id}}"
                                        [dataSource]="docType.AvailableFormats"
                                        valueExpr="FormatsId"
                                        displayExpr="FormatName"
                                        caption="Formats"
                                        infoText="Choose one or more.">
                                    </app-multiselectbox>
                                </div>
                            </app-layout-column>
                        </app-layout-row>
                        <app-layout-row>
                            <app-layout-column [width]="6">
                                    <div class="indent-properties">
                                    <app-textbox decorator formControlName="doctypeindisplayname_{{docType.DocumentType.Id}}" caption="Name shown to partner" infoText="From your trading partners point of view."></app-textbox>
                                </div>
                                <p><br></p>
                            </app-layout-column>
                        </app-layout-row>
                    }
                }
            </app-layout-column>
        </app-layout-row>

        <!-- Outgoing Document Types -->
        <app-layout-row margin="3rem">
            <app-layout-column [width]="12">
                <div class="sectionheader">Outgoing Document Types</div>
                <p class="sectionheadertext">What kinds of documents does your <b>partner want to receive from you</b>.<br>For each document type, choose one or more formats.<br>The partner will be able to suggest other document types and formats.</p>
                @for (docType of documentTypesOutWrapper(); track docType.DocumentType.Id)
                {
                    <app-layout-row>
                        <app-layout-column [width]="6">
                            <app-checkbox decorator="right-side" formControlName="doctypeoutcheckbox_{{docType.DocumentType.Id}}" caption="{{ docType.DocumentType.Name }}"></app-checkbox>
                        </app-layout-column>
                    </app-layout-row>
                    @if(getFormControlValue("doctypeoutcheckbox_"+docType.DocumentType.Id) === true){
                        <app-layout-row>
                            <app-layout-column [width]="6">
                                    <div class="indent-properties">
                                        <app-multiselectbox decorator formControlName="doctypeoutformat_{{docType.DocumentType.Id}}"
                                        [dataSource]="docType.AvailableFormats"
                                        valueExpr="FormatsId"
                                        displayExpr="FormatName"
                                        caption="Formats"
                                        infoText="Choose one or more.">
                                    </app-multiselectbox>
                                </div>
                            </app-layout-column>
                        </app-layout-row>
                        <app-layout-row>
                            <app-layout-column [width]="6">
                                    <div class="indent-properties">
                                    <app-textbox decorator formControlName="doctypeoutdisplayname_{{docType.DocumentType.Id}}" caption="Name shown to partner" infoText="From your trading partners point of view."></app-textbox>
                                </div>
                                <p><br></p>
                            </app-layout-column>
                        </app-layout-row>
                    }
                }
            </app-layout-column>
        </app-layout-row>

        <!-- Supported Transports -->
        <app-layout-row margin="3rem">
            <app-layout-column [width]="6">
                <div class="sectionheader">Transport setup</div>
                <p class="sectionheadertext">In this section you will be able to select which transport protocols you want your partner to be able to choose between.</p>
                <app-partner-onboarding-transport formControlName="supportedTransports"></app-partner-onboarding-transport>
            </app-layout-column>
        </app-layout-row>

    </form>
}

<!-- Footer buttons -->
@if (doneLoading()){
    <app-layout-row margin="3rem">
        <app-layout-column [width]="12">
            <div class="menubuttons">
                @if (reactiveFormGroup.enabled) {
                    <app-button primary width="10rem" [disabled]="!reactiveFormGroup.valid" (buttonClick)="reactiveFormSubmit()">Save</app-button>
                    @if(isNewPartner === true){
                        <app-button primary width="20rem" [disabled]="!reactiveFormGroup.valid" (buttonClick)="saveAndSendToPartner()">Save and send to Partner</app-button>
                    }
                    <app-button secondary width="10rem" (buttonClick)="reactiveFormCancel()">Cancel</app-button>
                } @else {
                    <app-button *bizPermissionRequired="['Partner_Action_SendOnboarding']" primary width="10rem" (buttonClick)="reactiveFormEdit()">Edit</app-button>
                }
            </div>
        </app-layout-column>
    </app-layout-row>
}
